export const EMAIL = 'sadegh.zarinmehr@gmail.com';
export const EITAA_MESSANGER = 'https://eitaa.com/sadegh_zr';
